module.exports = __webpack_public_path__ + "static/img/quanliucheng_04.efce9b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quanliucheng_04.png
// module id = +VR2
// module chunks = 1